import axios from "@/plugins/axios.js"

const actions = {
  fetchOrders({ commit, state }, force = false) {
    if(!force && state.orders.length) return
    return new Promise((resolve, reject) => {
      axios.get("/orders")
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDERS', response.data.data.orders)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchOrder({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/orders/${orderId}/show`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDER', response.data.data.order)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchDeliveries({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/order-deliveries/${orderId}/show`)
        .then((response) => {
          if(response.data.success){
              commit('SET_ORDER_DELIVERIES', response.data.data.deliveries)
           }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchMessages({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/order-messages/${orderId}/show`)
        .then((response) => {
          if(response.data.success){
              commit('SET_ORDER_MESSAGES', response.data.data.messages)
           }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  multipleAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.action, payload.formData)
        .then((response) => {
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
}

const getters = {}




const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders
  },
  SET_ORDER(state, order){
  	state.order = order
    if(state.orders.length){
      const dataIndex = state.orders.findIndex((o) => o.id == order.id);
      Object.assign(state.orders[dataIndex], order);
    }
  },
  DELETE_ORDER(state, orderId){
      const itemIndex = state.orders.findIndex((item) => item.id == orderId)
      state.orders.splice(itemIndex, 1)
  },


  /**************** THIS IS FOR DELIVERIES********************/
  SET_ORDER_DELIVERIES(state, deliveries){
    state.order.deliveries = [...deliveries]
  },
  ADD_DELIVERY(state, delivery){
    state.order.deliveries.unshift(delivery)
  },
  UPDATE_DELIVERY(state, delivery){
    const dataIndex = state.order.deliveries.findIndex((a) => a.id == delivery.id);
    Object.assign(state.order.deliveries[dataIndex], delivery);
  },
  DELETE_DELIVERY(state, deliveryId){
    const itemIndex = state.order.deliveries.findIndex((item) => item.id == deliveryId)
      state.order.deliveries.splice(itemIndex, 1)
  },

    /**************** THIS IS FOR MESSAGES********************/
  SET_ORDER_MESSAGES(state, messages){
    state.order.messages = [...messages]
  },
  ADD_MESSAGE(state, message){
    state.order.messages.push(message)
  },
  UPDATE_MESSAGE(state, message){
    const dataIndex = state.order.messages.findIndex((a) => a.id == message.id);
    Object.assign(state.order.messages[dataIndex], message);
  },
  DELETE_MESSAGE(state, messageId){
    const itemIndex = state.order.messages.findIndex((item) => item.id == messageId)
      state.order.messages.splice(itemIndex, 1)
  },
}

const state = {
  orders: [],
  order: {},
}

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

